module.exports = __webpack_public_path__ + "static/media/generic-hs.02ed39e4.jpeg";